export const USERDATAFIRM_SHOW_RESET = 'USERDATAFIRM_SHOW_RESET'
export const USERDATAFIRM_SHOW_SET_ERROR = 'USERDATAFIRM_SHOW_SET_ERROR'
export const USERDATAFIRM_SHOW_SET_RETRIEVED = 'USERDATAFIRM_SHOW_SET_RETRIEVED'
export const USERDATAFIRM_SHOW_TOGGLE_LOADING = 'USERDATAFIRM_SHOW_TOGGLE_LOADING'
